
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <section>
  <h2>Laste ortodontiline ravi</h2>

  <p>
    varajane ortodontiline kontroll aitab avastada ja suunata lõualuude ning hammaste arengut õigel ajal.

Õigeaegne sekkumine võib ennetada keerulisemaid probleeme tulevikus ning lihtsustada hilisemat ravi, kasutades lapsele sobivaid ja õrnu ravivõimalusi.
  </p>

  <p>
    Laste ortodontilise ravi all mõistame eelkõige I etapi ortodontilist ravi, 
    mis on suunatud hambumusanomaaliate ja hammaste lõikumisega seotud kõrvalekallete 
    varajasele märkamisele, ennetamisele ja õigeaegsele sekkumisele. Varases kasvufaasis 
    alustatud ravi aitab suunata hambumuse arengut soodsamas suunas, nii et edasine ravi 
    võib kulgeda normipärasemalt, lihtsamalt ja mõnel juhul ka lühemalt. Areneva hammaskonna 
    varajast hindamist ja õigeaegset ravi peab oluliseks ka AAPD.
  </p>

  <p>
    Laste ravis kasutame erinevaid aparaate vastavalt sellele, millist probleemi on vaja 
    korrigeerida. Näiteks võib ravi olla vajalik siis, kui ülalõug on kitsas, esineb 
    risthambumus, alumised hambad on ülemistest eespool, hambad ei lõiku õigel viisil või 
    on vaja toetada nina kaudu hingamist, keele õiget asendit ja neelamismustrit. Mõnel juhul 
    võib kitsa ülalõua laiendamine kuuluda ka hingamisteede ja unehäirete, sh uneapnoe, 
    käsitlusse, kuid seda hinnatakse alati individuaalselt ja vajadusel koostöös teiste 
    spetsialistidega.
  </p>

  <p>
    Kasutatavate aparaatide hulka võivad kuuluda kiire laiendaja ehk RPE, Quad-Helix, 
    Bi-Helix, kaarelaiendusplaat, müofunktsionaalsed trainerid, samuti vajadusel osalised 
    breketid ja laste esimeseks ravifaasiks mõeldud alignerid, nagu Invisalign First ja 
    Angel KID. Ravi valik sõltub lapse vanusest, kasvufaasist ja hambumuse eripärast.
  </p>

  <h3>Kui kaua laste ortodontiline ravi kestab?</h3>

  <p>
    Laste ortodontilise ravi kestus sõltub aparaadist ja ravi eesmärgist, kuid enamasti on 
    tegemist kuude kuni umbes aasta-paariga kestva I etapi raviga.
  </p>

  <ul>
    <li>
      <strong>Kiire laiendaja (RPE):</strong> aktiivne ravifaas kestab tavaliselt umbes 
      2–3 (mõnikord 4) nädalat, seejärel jääb aparaat tulemuse kinnistamiseks suhu veel 
      umbes 3–6 kuuks.
    </li>
    <li>
      <strong>Quad-Helix ja Bi-Helix:</strong> hambakaare laiendamise tulemus saavutatakse 
      enamasti umbes 4–6 kuuga, mille järel jääb aparaat tavaliselt veel 4–5 kuuks 
      ravitulemuse säilitamiseks suhu.
    </li>
    <li>
      <strong>Kaarelaiendusplaat:</strong> ravi kestab tavaliselt umbes 6 kuud kuni 
      1,5 aastat, sõltuvalt hambumushäire raskusest ja kandmise järjepidevusest.
    </li>
    <li>
      <strong>Trainer ja müofunktsionaalne ravi:</strong> trainerit kantakse tavaliselt 
      2 tundi päevas ja lisaks öösel ning minimaalne kasutusaeg on enamasti 6–12 kuud.
    </li>
  </ul>

  <p>
    Pärast aktiivset ravietappi võib olla vajalik ka retensiooniperiood, et saavutatud 
    tulemus püsiks ja hambad ei liiguks tagasi. Retensiooni kestus sõltub ravist ja 
    kasutatud aparaadist.
  </p>
  <h2>
    Esmase visiidi ABC vanematele
  </h2>
      <div style={{display:"flow"}}>

          
        <div className='ortodontia-l-photo' style={{float:"right"}}></div>
        <p>
          <strong>Ortodondi esmasele vastuvõtule on vajalik kaasa võtta saatekiri hambaarsti või perearsti käest! </strong>
        </p>
        
        <p>
          Palun kontrollige eelnevalt saatekirja olemasolu Terviseportaalist (digiloost). Saatekirja puudumisel lastele tasuline vastuvõtt.
        </p>
        
        <p>
          <strong>Kas olete esimest korda ortodondi juures? </strong>
        </p>
        <p>
          Uus olukord võib olla veidi hirmus nii lapsele kui ka vanemale. Soovime, et koostöö sujuks hästi, seega anname väikse ülevaate, mis aitaks teil lapsega ette valmistuda.
        </p>
        <p>
          <strong>
            Kuidas siis enne visiiti ette valmistuda? 
          </strong>
        </p>

        <p>
          Oleks hea kodus lapsega meeldivas õhkkonnas ja positiivses võtmes arutada, kuhu tullakse ja milleks seda vaja on. Teadmatus tekitab hirmu, kuid kui laps teab mis teda ees ootab, võib see pinged maandada. Vastuvõtule palun tulla puhaste hammastega. Ka kliinikus on olemas ühekordseid hambaharju, kui mujal pole võimalik enne visiiti hambaid pesta. Palume ka eelnevalt teha röntgenpildi hammastest (saatekirja saadame tavaliselt meilile või digitaalselt).
        </p>

        <p>
          <strong>
            Mida esimesel visiidil tehakse? 
          </strong>
        </p>
        <p>
          Esimesel visiidil teeb assistent kõigepealt diagnostika (fotod hammastest ja skaneeringu virtuaalsete mudelite jaoks). Pärast seda saab laps meie mugavasse tooli istuda, kus ortodont vaatab hambad üle ja mõõdab tavalise väikse joonlauaga hambumuse. Kui hambad on mõõdistatud, järgneb konsultatsioon, kus ortodont räägib teile erinevatest võimalustest raviks. Plaanide osas pole aga kohe vaja otsust teha, anname teile rahulikult aega kaaluda kõiki variante. Kokku võib terveks visiidiks varuda aega 30-45min.
        </p>

        <p>
          <strong>
            Mida esimesel visiidil vältida? 
          </strong>
        </p>
        <p>
          Hindame kui lapsevanem on toetav ja lapse jaoks olemas aga samas laseb arstil tööd teha ja ei sega protseduuri. Mõned laused on väga kerged tulema, kuid pole vajalikud. Soovitame vältida näiteks lauseid „see ei ole valus“, „sinuga ei juhtu midagi hullu“, „ära karda, nad ei tee süsti“. Kuigi see kõik on tõsi, siis need võivad siiski last hirmutada, kuna ta ei pruugi eelnevalt mõeldagi näiteks sellele, et süsti tehtaks. Kui aga laps siiski mingil põhjusel on väga pinges ja kardab, võib tooliga kõrval olla ja lapsel käest kinni hoida.
        </p>

        
        
      </div>
</section>
      </Container>
          </Container>

        </div>
    );
}